import SummaryScreenControlStyle from "./SummaryScreenControl.module.scss";
import  * as React from "react";
import { observer } from "mobx-react";
import { SummaryBarChart } from "./../SummaryBarChart/SummaryBarChart";
import { ISummaryScreenControlParams } from "./ISummaryScreenControlParams";

@observer
export class SummaryScreenControl extends React.Component<ISummaryScreenControlParams>{
    constructor(props: ISummaryScreenControlParams) {
        super(props, undefined);
       
    }

    render() {
        
        return <div className={SummaryScreenControlStyle.SummaryScreenControl}>
            <div className={`${SummaryScreenControlStyle.visualGraph} hidden-print`}>
                <SummaryBarChart 
                    measurementGroups={this.props.measurementGroups} 
                    width={1140} height={350} 
                    showScrollbar={this.props.measurementGroups.length <= 10 ? false: true } 
                    testResult={this.props.testResult} 
                    idForGradient={this.props.idForGradient} selectedUnit={this.props.selectedUnit} />
             </div>
            <div className={`${SummaryScreenControlStyle.visualGraph} visible-print-block`}>
                <SummaryBarChart 
                    measurementGroups={this.props.measurementGroups} 
                    width={1140} 
                    height={500} 
                    showScrollbar={false} 
                    testResult={this.props.testResult} 
                    idForGradient={this.props.idForGradient} 
                    selectedUnit={this.props.selectedUnit}  />
             </div>
        </div>
    }
}
